module.exports = __webpack_public_path__ + "img/button_blue_top.eac652fb.svg";